const _excluded = ["name"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fragment, useMemo, useState } from 'react';
import cn from 'classnames';
import { compact } from 'lodash-es';
import { Typography, Checkbox, ConfirmationModal } from 'seagull';
import { useStoreActions } from "../../../contexts";
import { useEventReporter } from "../../../event-reporter";
import { useApproveAmendments } from "../../../hooks/useApproveAmendments";
import { Intent } from "../../../infra/access-control";
import { approvalMethodNoticePeriodModel, relationshipModel, serviceModel, timeModel } from "../../../models";
import styles from "./ApproveAllModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const pluralize = function pluralize(text, count) {
  let suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';
  return count > 1 ? "".concat(text).concat(suffix) : text;
};
export default function ApproveAllModal(_ref) {
  let {
    agreement,
    amendments,
    invoices,
    charges,
    dismissModal
  } = _ref;
  const {
    reportButtonClick
  } = useEventReporter();
  const {
    api,
    logBI
  } = useStoreActions();
  const [showError, setShowError] = useState(false);
  const [approveInProgress, setApproveInProgress] = useState(false);
  const approveAmendments = useApproveAmendments();
  const firstAutoApprovalTime = useMemo(() => {
    var _relationshipModel$up;
    if (!approvalMethodNoticePeriodModel.isAutoApproval(agreement.amendmentsApprovalMethod)) return -1;
    const approvalApproveDates = compact(agreement.services.map(service => serviceModel.autoApprovalDate(service)));
    const netTermsApproveDate = (_relationshipModel$up = relationshipModel.updatedNetTerms(agreement)) === null || _relationshipModel$up === void 0 || (_relationshipModel$up = _relationshipModel$up.approvalMethod().autoApprovalDate()) === null || _relationshipModel$up === void 0 ? void 0 : _relationshipModel$up.getTime();
    if (netTermsApproveDate !== undefined) {
      approvalApproveDates.push(netTermsApproveDate);
    }
    return approvalApproveDates.length > 0 ? Math.min(...approvalApproveDates) : -1;
  }, [agreement]);
  const [requests, setRequests] = useState(new Map([{
    request: () => api.relationship.approveAllInvoices(agreement.id),
    label: 'issued invoice',
    count: invoices,
    name: 'invoices',
    enabled: false
  }, {
    request: () => approveAmendments(_objectSpread(_objectSpread({}, agreement), {}, {
      hideSuccessToast: true,
      throwOnError: true
    })),
    enabled: false,
    label: 'agreement amendment',
    count: amendments,
    name: 'amendments'
  }, {
    request: () => api.charge.approveAll(agreement.id),
    label: 'awaiting charge',
    count: charges,
    name: 'payments',
    enabled: false
  }].map(_ref2 => {
    let {
        name
      } = _ref2,
      req = _objectWithoutProperties(_ref2, _excluded);
    return [name, req];
  })));
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    as: "form",
    title: "Approve all requests?",
    className: styles.approveAllModalRoot,
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.modalContent,
      children: [/*#__PURE__*/_jsx(Typography, {
        as: "p",
        children: "Requests awaiting your approval:"
      }), /*#__PURE__*/_jsx("div", {
        children: [...requests].filter(_ref3 => {
          let [, {
            count
          }] = _ref3;
          return count > 0;
        }).map(_ref4 => {
          var _requests$get$enabled, _requests$get;
          let [name, {
            label,
            count
          }] = _ref4;
          return /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(Checkbox, {
              name: name,
              testId: "approve-all-modal-checkbox-".concat(name),
              checked: (_requests$get$enabled = (_requests$get = requests.get(name)) === null || _requests$get === void 0 ? void 0 : _requests$get.enabled) !== null && _requests$get$enabled !== void 0 ? _requests$get$enabled : false,
              className: styles.checkbox,
              onChange: e => {
                const currentValue = requests.get(name);
                if (currentValue) {
                  requests.set(name, _objectSpread(_objectSpread({}, currentValue), {}, {
                    enabled: e.currentTarget.checked
                  }));
                  setRequests(new Map(requests));
                }
              },
              children: /*#__PURE__*/_jsxs(Typography, {
                children: [/*#__PURE__*/_jsx("strong", {
                  children: count
                }), " ", pluralize(label, count)]
              })
            }), approvalMethodNoticePeriodModel.isAutoApproval(agreement.amendmentsApprovalMethod) && amendments > 0 && firstAutoApprovalTime >= 0 && /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph2",
              skin: "secondary",
              weight: "light",
              testId: "approve-all-modal-checkbox-".concat(name, "-description"),
              className: styles.checkboxDescription,
              children: name === 'amendments' ? "First amendment will be automatically accepted ".concat(timeModel.formatDaysUntil(firstAutoApprovalTime), " (").concat(timeModel.formatDate(firstAutoApprovalTime), ") unless declined.") : "Require".concat(count === 1 ? 's' : '', " approval in order to be paid.")
            })]
          }, name);
        })
      }), /*#__PURE__*/_jsx(Typography, {
        className: cn(styles.error, {
          [styles.errorShown]: showError
        }),
        testId: "approve-all-modal-error-label",
        skin: "error",
        as: "p",
        children: "Please select at least one option."
      })]
    }),
    primaryButtonLabel: "Approve",
    primaryButtonDisabled: approveInProgress,
    primaryButtonIntent: Intent.ApproveAllAmendments,
    onPrimaryButtonClick: () => {},
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: () => dismissModal({
      status: 'canceled'
    }),
    onSubmit: async e => {
      e.preventDefault();
      const requestsToPerform = [...requests].map(_ref5 => {
        let [, r] = _ref5;
        return r;
      }).filter(_ref6 => {
        let {
          enabled
        } = _ref6;
        return enabled;
      });
      if (requestsToPerform.length === 0) {
        setShowError(true);
        return;
      } else {
        setShowError(false);
      }
      setApproveInProgress(true);
      try {
        for (let index = 0; index < requestsToPerform.length; index++) {
          await requestsToPerform[index].request();
        }
        reportButtonClick('billing-hub-client-approved-amended-agreement-success');
        logBI(10588, {
          success: true
        });
        dismissModal({
          status: 'success'
        });
      } catch (e) {
        reportButtonClick('billing-hub-client-approved-amended-agreement-failure');
        logBI(10588, {
          success: false
        });
        dismissModal({
          status: 'error'
        });
      } finally {
        setApproveInProgress(false);
      }
    }
  });
}